<template>
  <footer>
    <div class="footer-content">
      <div class="left-content">
        <img :src="logoUrl" alt="Logo">
        <p>&copy; {{ copyrightText }}</p>
      </div>
      <a :href="supportEmail" class="support-icon" title="Soporte">
        <b-icon icon="chat-text"></b-icon>
      </a>
    </div>
  </footer>
</template>

<script>
import config from '@/plugins/config';

export default {
  name: 'FooterView',
  data() {
    return {
      logoUrl: config.branding.logo,
      copyrightText: config.branding.copyrightText,
      supportEmail: `mailto:${config.support.email}`
    };
  },

  computed: {
    menuBgColor() {
      return config.theme.menuBackgroundColor;
    }
  },
};
</script>

<style scoped>
footer {
  background-color: v-bind(menuBgColor);
  color: #ffffff;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 0;
}

.footer-content .left-content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 2vh;
}

.footer-content p {
  margin: 0;
  font-size: 0.85rem;
}

.footer-content img {
  height: 30px;
  width: auto;
  background-color: white;
  padding: 2px;
}

.support-icon {
  margin-right: 2vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  font-size: 1.2rem;
  transition: transform 0.2s;
}

.support-icon:hover {
  transform: scale(1.15);
}

@media (max-width: 600px) {
  .footer-content {
    height: auto;
  }
  .footer-content img {
    margin-top: 1vh;
    margin-bottom: 10px; 
  }
}
</style>
